module.exports = __webpack_public_path__ + "assets/b0fc2fcbd6bd0525a71ac04b639197cb.mp3";